import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { fluidPropTypes } from '../types';
import { breakpoints } from '../constants/mediaqueries';
import { SPACING_VERTICAL } from '../constants/spacings';
import { typeSizes } from '../constants/typography';

import { customMarkdown } from '../helpers/markdown';

import ExternalLink from './ExternalLink';
import { Wrapper, Image, MarkdownContent } from './ImageMarkdown';
import LocalisedLink from './LocalisedLink';
import MichelbergerImage from './MichelbergerImage';


const createLink = (link, contents, slug, hasUnderline = true) => (
  <Choose>
    <When condition={typeof link === 'object'}>
      <LocalisedLink hasUnderline={hasUnderline} to={`/${slug}/${link.slug}`}>{contents}</LocalisedLink>
    </When>
    <Otherwise>
      <ExternalLink hasUnderline={hasUnderline} href={link}>{contents}</ExternalLink>
    </Otherwise>
  </Choose>
);

const MarkdownContentCentered = styled(MarkdownContent)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  ${SPACING_VERTICAL.s};

  h4 {
    ${typeSizes.m};
  }

  * + * {
    margin-top: 1.75em; /* Generic spacing rule */
  }

  @media ${breakpoints.l} {
    margin-bottom: 0;
  }
`;

const ImageMarkdownCentered = ({ block, index, slug }) => {
  const {
    changesColorOnHover,
    hasBlendMode,
    image,
    text,
    title,
    internalLink,
    externalLink,
    linkText,
  } = block;

  const mbImage = (
    <MichelbergerImage
      changesColorOnHover={changesColorOnHover}
      hasBlendMode={hasBlendMode}
      image={image}
    />
  );

  return (
    <Wrapper index={index}>
      <Image>
        {createLink(internalLink || externalLink, mbImage, slug, false)}
      </Image>
      <If condition={text}>
        <MarkdownContentCentered>
          <If condition={title}><h4>{title}</h4></If>
          {customMarkdown(text)}
          {createLink(internalLink || externalLink, linkText, slug)}
        </MarkdownContentCentered>
      </If>
    </Wrapper>
  );
};

ImageMarkdownCentered.propTypes = {
  index: PropTypes.number.isRequired,
  block: PropTypes.shape({
    id: PropTypes.string,
    caption: PropTypes.string,
    changesColorOnHover: PropTypes.bool,
    externalLink: PropTypes.string,
    hasBlendMode: PropTypes.bool,
    internalLink: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }),
    image: PropTypes.shape({
      id: PropTypes.string,
      fluid: fluidPropTypes,
      inlineSvg: PropTypes.string,
    }),
    linkText: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  slug: PropTypes.string.isRequired,
};

export default ImageMarkdownCentered;
